let Screen = {

	//Определяем данные по-умолчанию для каждого компонента Vue
	data() {
		return {
			showed: false
		}
	},

	//В момент создания экземпляра компонента
	created() {

		//Если это главный компонент (скрин / экран)
		if (this.$options.screen) {

			let eventName = this.$options.name || '';

			//Создаём обработку события которое можно вызвать через Broadcast чтобы показать этот компонент
			Broadcast.on("Show " + eventName, (...params) => {

				//Показываем компонент
				this.show(...params);

			}, "vue-component-" + this._uid + "-" + this.$options.name);

			//Создаём обработку события которое можно вызвать через Broadcast чтобы обновить данные этого компонента
			Broadcast.on("Update " + eventName, (...params) => {

				//Обновляем компонент если он показан
				this.update("Update " + eventName, ...params);

			}, "vue-component-" + this._uid + "-" + this.$options.name);

			//Создаём обработку события которое можно вызвать через Broadcast чтобы скрыть этот компонент
			Broadcast.on("Hide " + eventName, () => {

				//Скрываем текущий компонент
				this.hide();

			}, "vue-component-" + this._uid + "-" + this.$options.name);

			//Если указаны имена событий вызов которых должен показать этот компонент
			if (this.$options.screen.showOn) {

				//Проходим по всем таким событиям
				this.$options.screen.showOn.forEach(eventName => {

					//Добавляем обработчик такого события
					Broadcast.on(eventName, () => {

						//Показываем компонент
						this.show();

					}, "vue-component-show-on-" + this._uid + "-" + this.$options.name);

				});

			}

			//Если указаны имена событий вызов которых должен обновить этот компонент
			if (this.$options.screen.updateOn) {

				//Проходим по всем таким событиям
				this.$options.screen.updateOn.forEach(eventName => {

					//Добавляем обработчик такого события
					Broadcast.on(eventName, (...params) => {

						//Обновляем компонент если он показан
						this.update(eventName, ...params);

					}, "vue-component-update-on-" + this._uid + "-" + this.$options.name);

				});

			}

			//Если указаны имена событий вызов которых должен скрыть этот компонент
			if (this.$options.screen.hideOn) {

				//Проходим по всем таким событиям
				this.$options.screen.hideOn.forEach(eventName => {

					//Добавляем обработчик такого события
					Broadcast.on(eventName, () => {

						//И скрываем текущий компонент
						this.hide();

					}, "vue-component-hide-on-" + this._uid + "-" + this.$options.name);

				});

			}

			//Обработываем другие события
			if (this.$options.screen.events) {

				//Проходим по всем таким событиям
				_.each(this.$options.screen.events, (event_fn, eventName) => {

					//Добавляем обработчик такого события
					Broadcast.on(eventName, (...args) => {

						event_fn.apply(this, args);

					}, "vue-component-event-" + this._uid + "-" + this.$options.name);

				});

			}

		}

	},

	mounted() {

		this.update('mounted');

	},

	destroyed() {

		//Если это главный компонент (скрин / экран)
		if (this.$options.screen) {

			//Преобразуем имя добавляя пробелы для создания событий вида Show Game Enter Dialog из имени GameEnterDialog
			let eventName = (this.$options.name || '').replace(/([A-Z])/g, ' $1').trim();

			//Убираем обработчики главных событий
			Broadcast.off(["Show " + eventName, "Update " + eventName, "Hide " + eventName], "vue-component-" + this._uid + "-" + this.$options.name);

			//Если указаны имена событий вызов которых должен показать этот компонент
			//Убираем обработчик таких событий
			if (this.$options.screen.showOn) Broadcast.off(this.$options.screen.showOn, "vue-component-show-on-" + this._uid + "-" + this.$options.name);

			//Если указаны имена событий вызов которых должен обновить этот компонент
			//Убираем обработчик таких событий
			if (this.$options.screen.updateOn) Broadcast.off(this.$options.screen.updateOn, "vue-component-update-on-" + this._uid + "-" + this.$options.name);

			//Если указаны имена событий вызов которых должен скрыть этот компонент
			//Убираем обработчик таких событий
			if (this.$options.screen.hideOn) Broadcast.off(this.$options.screen.hideOn, "vue-component-hide-on-" + this._uid + "-" + this.$options.name);

			//Если указаны другие события
			//Убираем обработчик таких событий
			if (this.$options.screen.events) Broadcast.off(_.keys(this.$options.screen.events), "vue-component-event-" + this._uid + "-" + this.$options.name);

		}

	},

	methods: {

		//Показываем компонент
		show(...params) {

			//Устанавливаем свойство showed которое должно обрабатываться в компоненте показывая и скрывая его
			this.showed = Date.now();

			this.update('show', ...params);

		},

		//Скрываем компонент
		hide() {

			this.showed = false;

		},

		//Обновляем компонент если он показан
		update(eventName, ...params) {

			//Обновляем только если компонент показан
			if (!this.showed) return;

			//Вызываем метод обновляющий данные Vue
			if (this.collectData) this.collectData(eventName, ...params);

			//Заставляем пересмотреть все данные
			this.$forceUpdate();

		},

		addUpdateEvent(eventNames) {

			if (!_.isArray(eventNames)) eventNames = [eventNames];

			_.each(eventNames, eventName => {

				Broadcast.on(eventName, (...params) => {

					this.update(eventName, ...params);

				}, "vue-component-update-on-" + this._uid + "-" + this.$options.name);

				this.$once('hook:beforeDestroy', () => {

					Broadcast.off(eventName, "vue-component-update-on-" + this._uid + "-" + this.$options.name);

				});

			});

		}

	}

};

export default Screen;
